import React, { createContext, useContext, useState, ReactNode } from 'react'

type PreferenceCardAction = 'assign' | 'unassign'

interface PreferenceCardContextType {
  preferenceCardAction: PreferenceCardAction
  setPreferenceCardAction: (action: PreferenceCardAction) => void
}

const PreferenceCardContext = createContext<
  PreferenceCardContextType | undefined
>(undefined)

export const usePreferenceCard = (): PreferenceCardContextType => {
  const context = useContext(PreferenceCardContext)
  if (context === undefined) {
    throw new Error(
      'usePreferenceCard must be used within a PreferenceCardProvider'
    )
  }
  return context
}

interface PreferenceCardProviderProps {
  children: ReactNode
}

export const PreferenceCardProvider: React.FC<PreferenceCardProviderProps> = ({
  children,
}) => {
  const [preferenceCardAction, setPreferenceCardAction] =
    useState<PreferenceCardAction>('assign')

  return (
    <PreferenceCardContext.Provider
      value={{ preferenceCardAction, setPreferenceCardAction }}
    >
      {children}
    </PreferenceCardContext.Provider>
  )
}
